const CHECKBOX_NAME = 'checkbox';
const SIGNUP_POPUP_COOKIE_NAME = 'signupPopupCookie';
const NEWSLETTER_SIGN_UP = 'newsletterSignUp';

const SIGNUP_POPUP_TIMEOUT = 10000;

export { CHECKBOX_NAME, SIGNUP_POPUP_COOKIE_NAME, SIGNUP_POPUP_TIMEOUT, NEWSLETTER_SIGN_UP };
